// Estilos da página filha Planos (/plans).
// Mockup: "Página filha — Planos (PlansManager · acesso pelo botão Planos)".
import { makeStyles, alpha } from "@material-ui/core/styles";
import { AEROS, stateText } from "../../styles/aerosTokens";

const usePlanPageStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  const border = isLight ? theme.palette.divider : "rgba(255,255,255,0.07)";

  return {
    // cards à esquerda, editor fixo à direita
    layout: {
      display: "grid",
      gridTemplateColumns: "minmax(0,1.5fr) 400px",
      gap: 20,
      alignItems: "start",
      [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" },
    },
    cardGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0,1fr))",
      gap: 12,
      [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
    },
    planCard: {
      backgroundColor: theme.palette.aeros.surface,
      border: `1px solid ${border}`,
      borderRadius: 14,
      padding: 16,
      display: "flex",
      flexDirection: "column",
      gap: 10,
      minWidth: 0,
    },
    planCardActive: { borderColor: alpha(AEROS.defaultPrimary, 0.45) },
    planHead: { display: "flex", alignItems: "center", gap: 8, minWidth: 0 },
    planName: {
      fontSize: 14,
      fontWeight: 700,
      color: theme.palette.text.primary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    tag: {
      fontSize: 10,
      fontWeight: 600,
      borderRadius: 5,
      padding: "2px 6px",
      flex: "none",
    },
    tagPublic: {
      color: stateText(theme, AEROS.success, "success"),
      backgroundColor: alpha(AEROS.success, 0.12),
    },
    tagTrial: {
      color: stateText(theme, AEROS.warning, "warning"),
      backgroundColor: alpha(AEROS.warning, 0.12),
    },
    cardActions: { marginLeft: "auto", display: "flex", gap: 2, flex: "none" },
    price: {
      fontSize: 22,
      fontWeight: 700,
      letterSpacing: "-0.02em",
      fontVariantNumeric: "tabular-nums",
      color: theme.palette.text.primary,
    },
    pricePer: { fontSize: 11, color: theme.palette.text.secondary, fontWeight: 500 },
    limits: {
      display: "flex",
      gap: 12,
      flexWrap: "wrap",
      fontSize: 11.5,
      color: theme.palette.text.secondary,
      "& b": { color: theme.palette.text.primary },
    },
    features: { display: "flex", flexWrap: "wrap", gap: 4 },
    // recurso ausente fica riscado, como no mockup
    feature: {
      fontSize: 10.5,
      fontWeight: 600,
      borderRadius: 5,
      padding: "2px 7px",
      color: theme.palette.text.primary,
      backgroundColor: isLight ? "rgba(15,20,40,0.05)" : "rgba(255,255,255,0.06)",
    },
    featureOff: {
      color: theme.palette.aeros.textTertiary,
      backgroundColor: "transparent",
      textDecoration: "line-through",
    },
    usage: { fontSize: 11, color: theme.palette.aeros.textTertiary },

    // ---- editor ----
    editor: {
      backgroundColor: theme.palette.aeros.surface2,
      border: `1px solid ${alpha(AEROS.defaultPrimary, 0.3)}`,
      borderRadius: 14,
      padding: 18,
      display: "flex",
      flexDirection: "column",
      gap: 12,
      position: "sticky",
      top: 16,
    },
    editorTitle: {
      fontSize: 13,
      fontWeight: 700,
      display: "flex",
      alignItems: "center",
      gap: 8,
      color: theme.palette.text.primary,
      "& .MuiSvgIcon-root": {
        fontSize: 17,
        color: stateText(theme, "#C08BFF", "purple"),
      },
    },
    editorGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0,1fr))",
      gap: 8,
    },
    span2: { gridColumn: "span 2" },
    toggleRow: { display: "flex", gap: 8 },
    toggleBox: {
      flex: 1,
      display: "flex",
      alignItems: "center",
      gap: 8,
      border: `1px solid ${border}`,
      borderRadius: 9,
      padding: "3px 4px 3px 10px",
      fontSize: 12,
      fontWeight: 600,
      color: theme.palette.text.primary,
      minWidth: 0,
    },
    toggleBoxOn: {
      borderColor: alpha(AEROS.defaultPrimary, 0.35),
      backgroundColor: alpha(AEROS.defaultPrimary, 0.06),
    },
    featuresLabel: {
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
      color: theme.palette.aeros.textTertiary,
      marginBottom: 8,
    },
    featureGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0,1fr))",
      gap: 0,
    },
    featureCheck: {
      display: "flex",
      alignItems: "center",
      gap: 4,
      fontSize: 12,
      margin: 0,
      color: theme.palette.text.secondary,
      minWidth: 0,
      "& .MuiFormControlLabel-label": {
        fontSize: 12,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .MuiCheckbox-root": { padding: 5 },
    },
    editorActions: { display: "flex", gap: 8, marginTop: 4 },
    editorButton: { flex: 1, borderRadius: 9, fontWeight: 600, fontSize: 12.5 },
  };
});

export default usePlanPageStyles;
